export const SANDBOX_LINK_URL = 'https://link.x.immutable.com'